import { ArrowLeftOutlined } from '@ant-design/icons'
import { Button, PageHeader, Space } from 'antd'
import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { useBack } from '@/hooks/useBack'

const CustomerDetailPageHeader: FC = ({}) => {
  const { t } = useTranslation()
  const handleBack = useBack()

  return (
    <Space>
      <Button onClick={handleBack} icon={<ArrowLeftOutlined />} />
      <PageHeader ghost={false} title={t('components.pages.customers.detail.pageHeader.title')} />
    </Space>
  )
}

CustomerDetailPageHeader.displayName = 'CustomerDetailPageHeader'
export default CustomerDetailPageHeader
